import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import authenticationApi from '../api/authentication';
import { useNavigate } from 'react-router-dom';

interface FormValues {
  userName: string;
  password: string;
}

export default function useLogin() {
  const navigate = useNavigate();
  const [apiError, setApiError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object({
    userName: Yup.string()
      .email('Kindly input a valid email')
      .required('Kindly input a valid email'),
    password: Yup.string()
      .required('No password provided')
      .min(6, 'Password is invalid'),
  });

  const formik = useFormik<FormValues>({
    initialValues: {
      userName: '',
      password: '',
    },
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: false,
    validationSchema,
  });

  async function handleSubmit(values: FormValues) {
    try {
      setIsLoading(true);
      const res = await authenticationApi.login(values);
      if (res.success) {
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('token_expires', res.data.accesstoken_Expires);
        localStorage.setItem('c-uid', res?.data?.UserId);
        localStorage.setItem('c-iid', res?.data?.InstitutionId);
        localStorage.setItem('c-username', res?.data?.UserName);
        localStorage.setItem('c-firstname', res?.data?.FirstName);
        localStorage.setItem('c-lastname', res?.data?.LastName);
        handleCloseAlert();
        navigate('/dashboard');
      } else {
        handleApiError(res.description);
      }
    } catch (e) {
      handleApiError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  }

  function handleApiError(error: string) {
    setApiError(error);
  }

  function handleCloseAlert() {
    setApiError('');
  }

  return { formik, apiError, isLoading, handleCloseAlert };
}
